var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import clsx from 'clsx';
import { Icon } from '../Icon/Icon.js';
import { CheckCircleIcon, ExclamationIcon, InformationCircleIcon, XCircleIcon, XIcon, } from '../icons/index.js';
export const Alert = (_a) => {
    var { as, align = 'leading', status, title, children, withClose = false, className, icon } = _a, rest = __rest(_a, ["as", "align", "status", "title", "children", "withClose", "className", "icon"]);
    const [close, setClose] = useState(false);
    if (close) {
        return null;
    }
    if (!icon) {
        switch (status) {
            case 'error':
                icon = React.createElement(XCircleIcon, null);
                break;
            case 'warning':
                icon = React.createElement(ExclamationIcon, null);
                break;
            case 'success':
                icon = React.createElement(CheckCircleIcon, null);
                break;
            case 'neutral':
            case 'primary':
                icon = null;
                break;
            case 'info':
                icon = React.createElement(InformationCircleIcon, null);
                break;
            default:
                break;
        }
    }
    if (icon !== null) {
        icon = (React.createElement(Icon, { className: "h-5 w-5", "aria-hidden": "true" }, icon));
    }
    const Component = as || 'div';
    return (React.createElement(Component, Object.assign({ className: clsx('relative block rounded-md p-4', [
            status === 'error' && 'text-content-on-negative bg-surface-negative',
            status === 'warning' &&
                'text-content-on-attention bg-surface-attention',
            status === 'success' &&
                'text-content-on-positive bg-surface-positive',
            status === 'info' && 'text-content-on-highlight bg-surface-highlight',
            status === 'neutral' && 'text-content-subdued bg-surface-subdued',
            status === 'primary' && 'text-content-on-primary bg-action-primary',
        ], className) }, rest),
        React.createElement("div", { className: clsx(align === 'center' && 'justify-center', 'flex') },
            !!icon && React.createElement("div", { className: "flex-shrink-0" }, icon),
            React.createElement("div", { className: clsx([!!icon && 'ms-3']) },
                title && React.createElement("h3", { className: "text-sm font-medium" }, title),
                children && (React.createElement("div", { className: clsx('text-sm', !!title && 'mt-2 ') }, children)),
                withClose && (React.createElement("span", { className: "absolute top-0 end-0 flex items-center me-2 mt-2" },
                    React.createElement("button", { onClick: () => setClose(true), type: "button", className: "inline-flex rounded-md p-1.5" },
                        React.createElement("span", { className: "sr-only" }, "Dismiss"),
                        React.createElement(XIcon, { className: "h-4 w-4", "aria-hidden": "true" }))))))));
};
//# sourceMappingURL=Alert.js.map